module.exports = __webpack_public_path__ + "static/22-648564b34a8f1be574ae53981f5e3518.jpg";